import React from "react";

import { PropsTypeSvg } from "@typings/global.types";

function TwitterSvg({ classNameProps, height, width }: PropsTypeSvg) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      className={classNameProps}
      width={width}
      height={height}
      viewBox='0 0 31 30'
      fill='none'
    >
      <circle cx='15.6668' cy='15' r='12' fill='#4A99E9' />
      <path
        d='M24.0668 11.5862C23.5374 11.821 22.9679 11.9802 22.3695 12.0508C22.98 11.6849 23.4481 11.1064 23.6685 10.4167C23.0974 10.7545 22.4654 11.0011 21.7929 11.1345C21.2542 10.5587 20.4865 10.2002 19.6364 10.2002C18.0051 10.2002 16.6819 11.5234 16.6819 13.1548C16.6819 13.3865 16.708 13.6112 16.7587 13.8285C14.3027 13.7048 12.1271 12.5291 10.6697 10.7413C10.4142 11.1778 10.2699 11.6853 10.2699 12.2267C10.2699 13.2515 10.791 14.1558 11.5841 14.6855C11.0992 14.6711 10.644 14.5377 10.2449 14.3169C10.2449 14.329 10.2449 14.3411 10.2449 14.3528C10.2449 15.7848 11.2634 16.9789 12.6147 17.2504C12.367 17.3179 12.1056 17.3546 11.8373 17.3546C11.6473 17.3546 11.4608 17.3362 11.2814 17.3015C11.657 18.4757 12.7481 19.3288 14.0405 19.3526C13.029 20.1457 11.7553 20.6181 10.3713 20.6181C10.1329 20.6181 9.89848 20.6037 9.66676 20.5767C10.974 21.4147 12.5273 21.9031 14.1954 21.9031C19.6298 21.9031 22.602 17.4014 22.602 13.4969C22.602 13.3693 22.5977 13.2414 22.5926 13.115C23.1699 12.698 23.6704 12.1784 24.0668 11.5862Z'
        fill='white'
      />
    </svg>
  );
}

export default TwitterSvg;
